import React, { FC, ReactNode, useEffect, useState } from 'react'
import styles from 'styles/components/accordion.module.scss'

type Props = {
  breadName: string
  expandStatus: string
  imageUrl: string
  resetExpandedStatus: () => void
  children: ReactNode
}

const SettingsAccordion: FC<Props> = (props) => {
  const { children, breadName, expandStatus, imageUrl, resetExpandedStatus } = props

  const [open, setOpen] = useState<boolean>(false)
  const toggleOpen = () => {
    resetExpandedStatus()
    setOpen((prevState) => !prevState)
  }

  // 一括で開く/閉じる
  useEffect(() => {
    if (expandStatus === 'expanded') {
      setOpen(true)
    } else if (expandStatus === 'folded') {
      setOpen(false)
    }
  }, [expandStatus])

  return (
    <div className={open ? styles.open : ''}>
      <div className={styles.settings}>
        <div className={styles.settings__header} onClick={toggleOpen}>
          <div className={styles.settings__image}>
            <img src={imageUrl} alt={breadName} />
          </div>
          <span className={styles.settings__name}>{breadName}</span>
          <span className={styles.settings__arrow} />
        </div>
        {children}
      </div>
    </div>
  )
}

export default SettingsAccordion
